import { useState, useEffect, useRef } from "react"
import { useLocation } from "react-router-dom";
import axios from "axios";

import {
    MaterialForm,
    OperationForm,
    QuestionnaireForm,
    ReportForm,
    CustomizedAppBar,
    LoadingComponent,
    CustomizedDialog,
    CustomizedConfirmDialog,
    ConclusionForm
} from "../../components";
import { Form, Constant, Operations, Materials, DB } from "../../constants";
import { ValidateInput, BusinessLogic, DataSynchronization } from "../../utilities";
import "./style.css";
import { useTranslation } from 'react-i18next';

const ignoreObject = {
    "_parametres_": true,
    "Matériel": true,
    "Exploitant": true,
    "options de relance": true,
    "Conclusion du contrôle": true,
    "copies et enregistrement": true
}

const FormPage = () => {
    let FormStep = [
        {
            step: 1,
            formName: "Matériel",
            element: []
        },
        {
            step: 2,
            formName: "Exploitant",
            element: []
        },
        {
            step: 3,
            formName: "",
            element: []
        },
        {
            step: 4,
            formName: "Conclusion du contrôle",
            element: []
        },
        {
            step: 5,
            formName: "copies et enregistrement",
            element: []
        }
    ]
    const { state } = useLocation()
    const pageRef = useRef()
    const formRef = useRef()

    const [formStep, setFormStep] = useState(FormStep)
    const [loading, setLoading] = useState(true)
    const [currentStep, setCurrentStep] = useState(1)
    const [title, setTitle] = useState('')
    const [isShowSummary, setIsShowSummary] = useState(false)
    const [error, setError] = useState([])
    const [openDialog, setOpenDialog] = useState(false)
    const [dialogTitle, setDialogTitle] = useState("")
    const [dialogBody, setDialogBody] = useState(<p></p>)
    const [dialogBtnLabel, setDialogBtnLabel] = useState("")
    const [openExitDialog, setOpenExitDialog] = useState(false)
    const { t: translate } = useTranslation();

    const getForm = () => {
        const formConstant = Form.getForm();
        if (!formConstant) {
            window.history.go(-1)
            return
        }

        const formData = formConstant[localStorage.getItem(Constant.localStorageKey.formId)]
        setTitle(formData["_parametres_"].nom)

        FormStep.forEach(form => {
            let temp = []
            if (form.formName === "") {
                //setFormSchema([formData])
                form.element = formData
                return
            }
            const currentForm = formData[form.formName]
            if (currentForm) {
                const keys = Object.keys(currentForm);
                keys.forEach(key => {
                    temp.push(currentForm[key])
                })

                // temp = temp.filter(f => f.typehtml !== "hidden")
                form.element = temp
            }
            else {
                FormStep = FormStep.filter(f => f.step !== form.step)
            }
        })

        setFormStep(FormStep)
        setLoading(false)
    }

    const nextStep = () => {
        pageRef.current.scrollIntoView()
        let step = currentStep
        let matched = false
        do {
            step += 1
            if (step === formStep.length + 1) {
                break
            }
            formStep.forEach(form => {
                if (form.step === step) matched = true
            })
        } while (!matched)
        setCurrentStep(step)
    }

    const backStep = () => {
        pageRef.current.scrollIntoView()
        let step = currentStep
        let matched = false
        do {
            step -= 1
            if (step === 0) {
                break
            }
            formStep.forEach(form => {
                if (form.step == step) matched = true
            })
        } while (!matched)
        setCurrentStep(step)
    }

    const previewForm = () => {
        let currentData = {}
        let data = new FormData(formRef.current)
        for (var pair of data.entries()) {
            currentData = { ...currentData, [pair[0]]: pair[1] };
        }

        const formConstant = Form.getForm();
        const formData = formConstant[localStorage.getItem(Constant.localStorageKey.formId)]
        const formKey = Object.keys(formData)
        const errorInput = []
        formKey.forEach(form => {
            if (form !== "_parametres_") {
                const currentForm = formData[form]
                const keys = Object.keys(currentForm);
                keys.forEach(key => {
                    if (currentForm[key].typehtml !== "hidden") {
                        const temp = currentData[key] || ""
                        const valid = ValidateInput(currentForm[key], { [key]: temp })
                        if (!valid) {
                            errorInput.push(key)
                        }
                    }
                })
            }
        })

        setError(errorInput)
        return {
            data: currentData,
            error: errorInput
        }
    }

    const submitForm = async (e) => {
        e.preventDefault();
        window.dispatchEvent(new Event(Constant.event.formSubmit))

        // check if contains error
        const formStatus = previewForm()
        if (formStatus.error.length > 0) {
            window.dispatchEvent(new Event(Constant.event.errorSubmission))
            setDialogTitle(translate('alert'))
            setOpenDialog(true)
            setDialogBody(<>
                <p>{translate('questionNotCompleted')}</p>
            </>)
            setDialogBtnLabel(translate('yes'))
            return
        }

        const requestData = new FormData(e.target)
        try {
            const res = await BusinessLogic.submitForm(requestData, true)
            if (res.success) {
                await linkMaterialToNewExploitant(res.id_materiel, res.id_exploitant)
                setDialogTitle(translate('alert'))
                setOpenDialog(true)
                setDialogBody(<>
                    <p>{translate('sentFormSucessful')}</p>
                    <p>{translate('reportId')} {res.id_controle}</p>
                </>)
                setDialogBtnLabel(translate('ok'))
                localStorage.setItem(Constant.localStorageKey.formSubmitted, true)
            }
            else {
                await updateMaterial(requestData, res.id_materiel, res.id_exploitant)
                await updateOperation(requestData, res.id_exploitant)
                setDialogTitle(translate('alert'))
                setOpenDialog(true)
                setDialogBody(<>
                    <p>{translate('noConnection')}</p>
                    <p>{translate('reportAddedToWaitingForSynchronize')}</p>
                </>)
                setDialogBtnLabel("OK")
            }
            window.onpopstate = () => { /* This is intentional */ }
        } catch (e) {
            console.log(e)
            setDialogTitle(translate('alert'))
            setOpenDialog(true)
            setDialogBody(<p>{translate('systemWentWrong')}</p>)
            setDialogBtnLabel("OK")
        }
    }

    const updateMaterial = async (formData, materialId, exploitantId) => {
        const keys = ["materiel-id", "materiel-annee_fabrication", "materiel-capacite", "materiel_centre_gravite", "materiel-categorie", "materiel-immat", "materiel-marque", "materiel-mise_en_circulation", "materiel-numchassis", "materiel-numparc", "materiel-numserie", "materiel-type"]
        let formDataToSave = Object.fromEntries(formData.entries())

        let currentMaterial = [];
        let id = 0
        const materialsDataQuery = await DB.materialsData.toArray();
        if (materialsDataQuery.length > 0) {
            materialsDataQuery.forEach(query => {
                if (query.userId === localStorage.getItem(Constant.localStorageKey.userId)) {
                    currentMaterial = query.material;
                    id = query.id
                }
            })
        }

        let modifiesMaterial = currentMaterial.filter(material => material.materiel_id === materialId)
        if (modifiesMaterial.length > 0) {
            modifiesMaterial = modifiesMaterial[0]
        }
        else {
            modifiesMaterial = {}
        }

        keys.forEach(key => {
            const label = key.replace("-", "_")
            if (formDataToSave[key]) {
                modifiesMaterial[label] = formDataToSave[key]
            }
        })

        //set change exploitant link if exploitant change
        modifiesMaterial["materiel_exploitant_id"] = `${exploitantId}`

        const updatedMaterial = await DataSynchronization.synchronizeMaterial(currentMaterial, [modifiesMaterial], false)
        await DB.materialsData.update(id, {
            material: updatedMaterial,
            userId: localStorage.getItem(Constant.localStorageKey.userId)
        });
        Materials.setMaterials(updatedMaterial)
    }

    const updateOperation = async (formData, exploitantId) => {
        const keys = ["exploitant-adresse1", "exploitant-adresse2", "exploitant-codepostal", "exploitant-fax", "exploitant-id", "exploitant-identifiant_client", "exploitant-mail", "exploitant-raisonsociale", "exploitant-siret", "exploitant-tel", "exploitant-ville"]
        let formDataToSave = Object.fromEntries(formData.entries())

        let currentOperation = {};
        let id = 0
        const operationDataQuery = await DB.operationData.toArray();
        if (operationDataQuery.length > 0) {
            operationDataQuery.forEach(query => {
                if (query.userId === localStorage.getItem(Constant.localStorageKey.userId)) {
                    currentOperation = query.operation
                    id = query.id
                }
            })
        }

        let modifiesOperation = currentOperation.filter(operation => operation.exploitant_id == exploitantId)
        if (modifiesOperation.length > 0) {
            modifiesOperation = modifiesOperation[0]
        }
        else {
            modifiesOperation = {}
        }

        keys.forEach(key => {
            const label = key.replace("-", "_")
            if (formDataToSave[key]) {
                modifiesOperation[label] = formDataToSave[key]
            }
        })

        const updatedOperation = await DataSynchronization.synchronizeOperation(currentOperation, [modifiesOperation], false)
        await DB.operationData.update(id, {
            operation: updatedOperation,
            userId: localStorage.getItem(Constant.localStorageKey.userId)
        });
        Operations.setOperation(updatedOperation)
    }

    const linkMaterialToNewExploitant = async (materialId, exploitantId) => {
        let currentMaterial = [];
        let id = 0
        const materialsDataQuery = await DB.materialsData.toArray();
        if (materialsDataQuery.length > 0) {
            materialsDataQuery.forEach(query => {
                if (query.userId === localStorage.getItem(Constant.localStorageKey.userId)) {
                    currentMaterial = query.material;
                    id = query.id
                }
            })
        }

        for (let material of currentMaterial) {
            if (material.materiel_id === materialId) {
                material.materiel_exploitant_id = `${exploitantId}`
                break
            }
        }

        await DB.materialsData.update(id, {
            material: currentMaterial,
            userId: localStorage.getItem(Constant.localStorageKey.userId)
        });
        Materials.setMaterials(currentMaterial)
    }

    const showSummary = () => {
        setIsShowSummary(true)
        const formStatus = previewForm()
        window.dispatchEvent(new CustomEvent(Constant.event.renderReport, { detail: { data: formStatus.data, error: formStatus.error } }))
    }

    const closeSummary = () => {
        setIsShowSummary(false)
    }

    const goToSpecificStep = (e) => {
        pageRef.current.scrollIntoView()
        setCurrentStep(e.detail.step)

        const el = document.getElementById(e.detail.inputName)
        setTimeout(() => {
            if (el) {
                el.scrollIntoView({ block: "center" })
                el.focus()
            }
        }, 0);
    }

    const backToOptionPage = () => {
        window.history.go(-1)
    }

    const setEntries = () => {
        window.history.pushState(null, "", "")
    }

    const backBtnClick = (e) => {
        setOpenExitDialog(true)
    }

    const handleCloseSubmissionDialog = () => {
        setOpenDialog(false);
        if (error.length == 0) {
            window.history.go(-3)
        }
        else {
            const firstErrorEle = error[0]
            let step = 0
            for (let form of formStep) {
                let isFound = false
                if (!form.element.length) {
                    let temp = {}
                    const tempEle = form.element
                    for (let key of Object.keys(tempEle)) {
                        if (!ignoreObject[key]) {
                            temp = { ...temp, ...tempEle[key] }
                        }
                    }
                    isFound = temp[firstErrorEle] !== undefined
                }
                else {
                    isFound = form.element.filter(el => el.name === firstErrorEle).length > 0
                }

                if (isFound > 0) {
                    step = form.step
                    break
                }
            }

            goToSpecificStep({ detail: { step, inputName: firstErrorEle } })
        }
    }

    useEffect(() => {
        setLoading(true)
        getForm()

        setEntries();
        window.onpopstate = backBtnClick;

        window.addEventListener(Constant.event.showSummary, showSummary)
        window.addEventListener(Constant.event.closeSummary, closeSummary)
        window.addEventListener(Constant.event.goToSpecificStep, goToSpecificStep)

        return () => {
            window.removeEventListener(Constant.event.showSummary, showSummary)
            window.removeEventListener(Constant.event.closeSummary, closeSummary)
            window.removeEventListener(Constant.event.goToSpecificStep, goToSpecificStep)
        }
    }, [])

    return (
        <div ref={pageRef} className={`page ${state && state.prev ? "page--prev" : ""}`}>
            <CustomizedAppBar title={title} onBackButtonClick={backToOptionPage} />
            <CustomizedConfirmDialog
                open={openExitDialog}
                title="Avertissement"
                confirmBtnLabel={translate('confirm')}
                cancelBtnLabel={translate('cancel')}
                onCancel={() => {
                    setOpenExitDialog(false)
                    setEntries()
                }}
                onConfirm={() => {
                    window.history.go(-1)
                }}
            >
                <p>{translate('quitFormAlert')}</p>
            </CustomizedConfirmDialog>
            <div className="form-group">
                {!loading ? <form ref={formRef} method='POST' autoComplete="off" onSubmit={submitForm}>
                    {currentStep !== 1 && !isShowSummary ? <div className='navigate-button'>
                        <button className="return-button" type='button' onClick={backStep}>{translate('back')}</button>
                    </div> : null}
                    <input name='formulaire-id' type={"hidden"} value={localStorage.getItem(Constant.localStorageKey.formId)} />
                    <MaterialForm isHidden={currentStep != 1} formData={formStep[0].element} error={error} />
                    <OperationForm isHidden={currentStep != 2} formData={formStep[1].element} error={error} />
                    <QuestionnaireForm isHidden={currentStep != 3} formData={formStep[2].element} error={error} />
                    {formStep.filter(form => form.step === 4).length > 0 ? <ConclusionForm isHidden={currentStep != 4} formData={formStep[3].element} error={error} /> : null}
                    <ReportForm isHidden={currentStep != 5} formData={formStep[formStep.length - 1].element} error={error} />
                    {currentStep < formStep.length ? <div className='navigate-button'>
                        <button className="next-button" type='button' onClick={nextStep}>{translate('next')}</button>
                    </div> : null}
                </form> : <LoadingComponent />}
                <p style={{ visibility: "hidden" }}>p</p>
            </div>
            <CustomizedDialog
                open={openDialog}
                title={dialogTitle}
                showActionButton={true}
                closeBtnLabel={dialogBtnLabel}
                onClose={handleCloseSubmissionDialog}
            >
                {dialogBody}
            </CustomizedDialog>
        </div>
    );
}

export default FormPage;